import { CompanySizeNumber } from 'signup-constants/signupData/CompanySizeNumber';
export function getCompanyDetails(state) {
  const {
    companyDetails
  } = state;
  return companyDetails;
}
export function getCompanySize(state) {
  const {
    companyDetails
  } = state;
  return companyDetails && companyDetails.companySize;
}
export function getIsVSBPortal(state) {
  const companySize = getCompanySize(state);
  return companySize && (companySize === CompanySizeNumber.TwoToFive || companySize === CompanySizeNumber.One);
}